import { Attachment } from '../../shared-components/models/attachment.model';
import { ClassroomSummary } from '../../classroom360/classroom-summary/models/classroom-summary.model';
import { StudentTeams } from '../../classroom360/student-teams/student-teams.model';
import { StudentList } from '../../classroom360/student-lists/student-list.model';

export class MassEmail {
    Attachments: Attachment[] = [];
    AdditionalRecipients: AdditionalRecipients = new AdditionalRecipients();
    Body: string;
    MassEmailClasses: ClassroomSummary[] = [];
    ContactTypes: any[] = [];
    From: string;
    HouseholdRecipientType: string;
    IncludeAll: boolean;
    NonHouseholdRecipientType: string;
    ReferringPage: string;
    SelectedContactTypes: any[] = [];
    Signature: string;
    StudentRecipientType: string;
    Students: MassEmailStudent[] = [];
    Subject: string;
    TeacherRecipientType: string;
    SendEmailToTeachers: boolean;
    SendEmailToTeamStaffMembers: boolean;
    CreateCommunicationLog: boolean;
    Recipients: Recipient[] = [];
    OneEmailPerHousehold: boolean;
    // Non DTO Field
    StudentIds: number[] = [];
    selectAllForMassEmail: boolean;
    selectedStudentsCheckAll: boolean;
    selectedClassesCheckAll: boolean;
    recipientsSelected: boolean; // if the user has previously selected recipients, using this to show save and cancel buttons
    MassEmailStudentTeams: StudentTeams[] = [];
    selectedTeamsCheckAll: boolean;
    // Student List
    MassEmailStudentLists: StudentList[] = [];
    selectedListsCheckAll:boolean;
}

export class MassEmailStudent {
    Id: number;
    StudentNumber: string;
    Name: string;
    FirstName: string;
    LastName: string;
    MiddleName: string;
    NickName: string;
    GradeLevel: string;
    Email: string;
    SubjectSections: number[];
    StudentTeams: number[];
    StudentContacts: StudentContact[];
    IsSelected: boolean;
    SelectedClasses: any[];
    SelectedTeams: any[];

    SelectedLists:any[];
    StudentLists: number[];

}
export class ContactTypes {
    id: string;
    label: string;
}
export class Recipient {
    StudentID: number;
    To: StudentContact[] = [];
    CC: StudentContact[] = [];
    BCC: StudentContact[] = [];
}

export class StudentContact {
    ID: number;
    Email: string;
    Relationship: string;
    IsGuardian: boolean;
    IsPrimaryParent: boolean;
    RequestsMailings: boolean;
    FirstName: string;
    LastName: string;
}

export class MassEmailPreferences {
    Signature: string;
    CreateCommunicationLog: boolean;
}

export class MassEmailAttachment {
    Id: number;
    Base64String: string;
    OriginalFileName: string;
    FileType: string;
    FileDescription: string;
    FileExtension: string;
    FileName: string;
}

export class AdditionalRecipients {
    bcc: string; // test@email.com; test2@email.com
    cc: string; // test@email.com; test2@email.com
    to: string; // test@email.com; test2@email.com
}
